import { ChainId } from '@uniswap/sdk'
import MULTICALL_ABI from './abi.json'
import { SupportedChainId } from '../index'
import { ACTIVE_CHAIN_ID, getActiveChainConfig, CHAIN_CONFIGS } from '../chains'

const MULTICALL_NETWORKS: { [chainId in SupportedChainId]?: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.ROPSTEN]: '0x53C43764255c17BD724F74c4eF150724AC50a3ed',
  [ChainId.KOVAN]: '0x2cc8688C5f75E365aaEEb4ea8D6a480405A48D2A',
  [ChainId.RINKEBY]: '0x42Ad527de7d4e9d9d011aC45B31D8551f8Fe9821',
  [ChainId.GÖRLI]: '0x77dCa2C955b15e9dE4dbBCf1246B4B85b651e50e'
}

// Add multicall address for active chain if configured
const activeChain = getActiveChainConfig()
if (activeChain.contracts.multicall) {
  MULTICALL_NETWORKS[ACTIVE_CHAIN_ID] = activeChain.contracts.multicall
}

// Get chains without Multicall from chain configs
export const CHAINS_WITHOUT_MULTICALL: number[] = Object.values(CHAIN_CONFIGS)
  .filter(config => !config.features.hasMulticall)
  .map(config => config.chainId)

export { MULTICALL_ABI, MULTICALL_NETWORKS }
